import React from "react";

function ApaItuDanai() {
    return (
        <>
            <div className="container-1">
                <div className="section-txt tentang-kami">
                    <div className="section-title">
                        <h2 className="text-header">Apa itu <span>Danai.id</span></h2>
                    </div>
                    <p>
                        <strong>Danai.id</strong> merupakan platform Layanan Pendanaan Bersama Berbasis Teknologi Informasi yang
                        <strong> berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK).</strong><br/>
                        Melalui penerapan teknologi, <strong>Danai.id menghadirkan solusi layanan keuangan yang inovatif </strong>
                        untuk membantu masyarakat memperoleh akses pendanaan secara lebih mudah, cepat, dan terpercaya.
                    </p>
                    <p>
                        Didukung oleh <strong>PT Adiwisista Finansial Teknologi</strong> sebagai badan usaha pengelola, <strong>Danai.id terus berinovasi untuk menyediakan
                        layanan keuangan yang memudahkan setiap langkah Anda menuju tujuan finansial.</strong>
                    </p>
                </div>
            </div>
        </>
    );
}

export default ApaItuDanai;